import { useCallback } from 'react';
import { useSelector } from 'react-redux';

const usePermission = () => {
  const currentUser = useSelector(
    (state) => state.accountReducer.currentUser?.user
  );

  const userPermission = useCallback(
    (type, action) => {
      const currentPermission = currentUser?.permissions?.[type]?.[action];
      if (!currentPermission) return {};
      return {
        ...currentPermission,
        permission: Boolean(currentPermission.permission),
      };
    },
    [currentUser?.permissions]
  );

  return { userPermission };
};
export default usePermission;
